
import React, { Suspense, useEffect, useState } from 'react'
// import Header from "../components/Header";
import Form from "../components/Form";
// import Calculator from "../components/Calculator";
// import Glnetwork from "../components/Glnetwork";
// import Availgl from "../components/Availgl";
// import Solution from "../components/Solution";
// import Faq from "../components/Faq";
import { lazy } from 'react';

// const Calculator = lazy(() => import("../components/Calculator.js"));
const Availgl = lazy(() => import("../components/Availgl.js"));
const Solution = lazy(() => import("../components/Solution.js"));
const Faq = lazy(() => import("../components/Faq.js"));
const Glnetwork = lazy(() => import("../components/Glnetwork.js"));

function Homepage() {
  const [executed, setExecuted] = useState(false);
  const [syncADL, setSyncADL] = useState(0);
  useEffect(() => {
    if (!executed) {
      window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
            event: 'gold_loan_index_page',
        });
        // console.log("dataLayer", window.dataLayer);
        setExecuted(true);
    }
    
}, []);

  return (
    <>

      {/* <Header /> */}
      <Suspense fallback={<>Loading...</>}>
      <Form />

      {/* Disclaimer Section */}
      <article className="disclaimer_banner_sec" style={{ padding: '20px 0' }}>
        <div className="container">
          <div className="disclaimer_sec" style={{ fontSize: '12px', color: '#000000' }}>
            <h6 style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '4px', color: '#000000' }}>Minimum Loan Amount:</h6>
            <ul style={{ paddingLeft: '25px', marginBottom: '0', listStyleType: 'disc' }}>
              <li style={{ display: 'list-item', listStyleType: 'disc' }}>₹ 3 lakh for 'New to Bank' customers (i.e., customers who do not have an existing relationship with ICICI Bank), in metro locations</li>
              <li style={{ display: 'list-item', listStyleType: 'disc' }}>₹ 2 lakh for 'New to Bank' customers (i.e., customers who do not have an existing relationship with ICICI Bank), in non-metro locations</li>
            </ul>
          </div>
        </div>
      </article>

      {/* <Calculator  syncADL = {syncADL}/> */}
      <Glnetwork />
      <Availgl />
      <Solution />
      <Faq setSyncADL = {setSyncADL} syncADL = {syncADL} />
      </Suspense>

    </>
  );
}

export default Homepage;
